import { useDispatch } from "react-redux";

import { BookmarkRegularV6 } from "@shared/v2/Icomoon";
import format from "@shared/formatters";
import ActivityContainer from "./ActivityContainer";
import { activityCommonDefaultProps, activityCommonPropTypes, STYLES } from "../common";
import Header from "./Header";
import PipedElements from "../PipedElements";
import CategoryContainer from "./CategoryContainer";
import DataField from "./DataField";
import { useTheme } from "../../../../reducers/layoutReducer/selectors";
import ActivityBtns from "./shared/ActivityBtns";
import { setCallParams } from "../../../../reducers/dialerReducer/dialerReducer";

const SavedSearchActivity = ({ activity, onReadChange }) => {
  const isPlace = useTheme()?.name === "place-theme";
  const dispatch = useDispatch();

  return (
    <ActivityContainer activity={activity} onReadChange={onReadChange}>
      <Header
        category={
          <CategoryContainer containerClassName={STYLES.badgeThemed(isPlace)} Icon={BookmarkRegularV6}>
            Saved Search
          </CategoryContainer>
        }
        personName={`${activity.data.subjectFirstName} ${activity.data.subjectLastName}`}
        time={activity.createdAt}
        onReadChange={onReadChange}
        loading={activity.loading}
        read={activity.read}
      />
      <div className={`${STYLES.contentContainer} tw-text-14d`}>
        <PipedElements>
          {activity.data?.searchLocation && <span>{activity.data?.searchLocation}</span>}
          <DataField
            label="Bed"
            data={
              (activity.data?.searchBedMin || activity.data?.searchBedMax) &&
              `${activity.data?.searchBedMin} - ${activity.data?.searchBedMax}`
            }
          />
          <DataField
            label="Bath"
            data={
              (activity.data?.searchBathsMin || activity.data?.searchBathsMax) &&
              `${activity.data?.searchBathsMin} - ${activity.data?.searchBathsMax}`
            }
          />
        </PipedElements>
        <PipedElements>
          <DataField
            label="Price"
            data={
              (activity.data?.searchPriceMin || activity.data?.searchPriceMax) &&
              `${format.currency(activity.data?.searchPriceMin, 0)} - ${format.currency(activity.data?.searchPriceMax, 0)}`
            }
          />
          {activity.data?.additionalFilters && <span>{activity.data?.additionalFilters}</span>}
        </PipedElements>
        <ActivityBtns
          callHandlr={() => {
            if (activity?.personUuid) {
              dispatch(
                setCallParams({ leadUuids: activity.personUuid, callSource: "Saved Search Activity" }),
              );
            }
          }}
        />
      </div>
    </ActivityContainer>
  );
};

export default SavedSearchActivity;

SavedSearchActivity.propTypes = {
  ...activityCommonPropTypes,
};

SavedSearchActivity.defaultProps = {
  ...activityCommonDefaultProps,
};
